export const DEFAULT_ALERT_SCORES = [
  {
    id: '0,1,6',
    name: 'AML-TM Detection'
  },
  {
    id: '4,13',
    name: 'Transaction Screening'
  },
  {
    id: '2,3,30',
    name: 'Name Screening'
  },
  {
    id: '5,10,11,12,14',
    name: 'Customer Risk Scoring'
  },
  {
    id: '21',
    name: 'Fraud Detection'
  },
  {
    id: '25,29',
    name: 'Fraud Prevention'
  },
  {
    id: '18',
    name: 'Prospect Screening'
  }
];

export const PROD_IDS = {
  AML_TM: {
    ID: '0,1,6',
    NAME: 'AML-TM'
  },
  TS: {
    ID: '4,13',
    NAME: 'Transaction Monitoring'
  },
  NS: {
    ID: '2,3,30',
    NAME: 'Name Screening'
  },
  CRS: {
    ID: '5,10,11,12,14',
    NAME: 'Customer Risk Screening'
  },
  FRAUD: {
    ID: '21',
    NAME: 'Fraud Survelliance'
  },
  FRAUD_PREV: {
    ID: '25',
    NAME: 'Fraud Prevention'
  },
  FRAUD_PREV_BATCH: {
    ID: '29',
    NAME: 'Fraud Prevention'
  },
  RT_FRAUD: {
    ID: '24',
    NAME: 'Fraud Prevention'
  }
};

// FIN-13233 — resolve a SINGLE numeric alert source id to its product label.
//
// The source of truth is DEFAULT_ALERT_SCORES, which keys products by a CSV GROUP of source
// ids ('0,1,6', '2,3,30', '4,13', '5,10,11,12,14'). Callers were comparing one id against
// those group strings with `===`:
//
//     alertSourceId === PROD_IDS.AML_TM.ID     // '6' === '0,1,6'  -> false, always
//
// so only the single-valued entries could ever match. Every grouped product — AML/TM, Name
// Screening, Transaction Screening, CRS — fell through to '-'. That is the reported bug:
// source 29 rendered and 2, 6 and 30 did not.
//
// Expanding the groups once into a flat id -> label lookup fixes all of them together.
//
// Built from DEFAULT_ALERT_SCORES rather than PROD_IDS on purpose: DEFAULT_ALERT_SCORES is
// what the Alert Source FILTER dropdown renders, so the column label and the filter option a
// user picked now read identically. PROD_IDS carries drifted copy for the same ids
// ('Fraud Survelliance' for 21, 'Transaction Monitoring' for the Transaction Screening
// group) and reusing it would have silently relabelled source 21, which renders correctly
// today.
const SOURCE_ID_LABEL_GROUPS = [
  ...DEFAULT_ALERT_SCORES.map(({ id, name }) => [id, name]),
  // 24 (RT Fraud IAD Run Instance) is absent from the filter dropdown because run-instance
  // alerts are not a user-selectable product. It still reaches this column, and this screen
  // has always labelled it 'Fraud Prevention' — preserved deliberately. NOTE: the backend
  // calls 24 'RT Fraud' (AlertSource.scala:165-170); realigning the two is a separate,
  // user-visible change and is out of FIN-13233's scope.
  [PROD_IDS.RT_FRAUD.ID, PROD_IDS.RT_FRAUD.NAME]
];

export const SOURCE_ID_TO_PRODUCT_NAME = SOURCE_ID_LABEL_GROUPS.reduce(
  (acc, [ids, name]) => {
    String(ids)
      .split(',')
      .forEach((id) => {
        const key = id.trim();
        if (key) acc[key] = name;
      });
    return acc;
  },
  {}
);

/**
 * Product label for one alert source id, or '-' when the id is unknown.
 * Accepts a number or a string; ids arrive as strings from the API.
 */
export const getAlertSourceName = (alertSourceId) => {
  if (alertSourceId === null || alertSourceId === undefined) return '-';
  return SOURCE_ID_TO_PRODUCT_NAME[String(alertSourceId).trim()] || '-';
};
